import 'slick-carousel';
import Plyr from "plyr";
import {
    latestNewsSlider,
    wonderSlider,
    headerWonderSlider,
    votingPhasesSlider,
    compactMediaSlider,
    mediaSlider,
    navMediaSlider,
} from "./config";

export const slider = {
    isInitialized: false,

    /**
     * Init sliders if required
     */
    init: function () {
        if ( !slider.isInitialized ) {
            /* Set up and prepare The Latest News Sliders */
            $('.latest-news-slider').slick(latestNewsSlider);

            /* Set up and prepare Wonder Sliders */
            $('.wonder-slider').slick(wonderSlider);

            /* Set up and prepare Wonder Sliders */
            $('.header-wonder-slider').slick(headerWonderSlider);

            /* Set up and prepare Compact Media Sliders */
            $('.media-slider-compact').slick(compactMediaSlider);

            /* Set up and prepare Media Sliders */
            $('.media-slider, .media-slider-nav').on('init reInit', function (event, slick) {
                slick.$slides.each(function () {
                    const photo = $(this).find('.photo');
                    const video = $(this).find('.video');

                    if (photo.length !== 0) {
                        $(this).addClass('photo');
                    }

                    if (video.length !== 0) {
                        $(this).addClass('video');
                    }
                });
            });

            $('.media-slider').slick(mediaSlider);

            $('.media-slider-nav').slick(navMediaSlider);

            $('.voting-phases-slider').slick(votingPhasesSlider);

            // Set new state, init only once
            slider.isInitialized = true;
        }

        // Photos/Videos Filter
        slider.sliderFilters();

        // Re-Init after new content loaded
        $(window).one('post-load', function () {
            slider.isInitialized = false;
        });
    },

  /**
   * Handle Plyr Player when Slides change
   * todo: Currently not in use
   * @param event
   * @param slick
   * @param currentSlide
   * @param nextSlide
   */
    slideChange: function (event, slick, currentSlide, nextSlide) {
        let $slide = $(".slick-active[data-slick-index='" + currentSlide + "']");
        let $nextSlide = $(".slick-slide[data-slick-index='" + nextSlide + "']");

        let $wrapper = $slide.find('.js-videoWrapper');
        let videoID = '#' + $wrapper.attr('id');

      // Nothing if no video
        if ( videoID !== undefined ) {
          // Just play the next video if the current is playing as well
            if ( $(videoID + ' .plyr').hasClass('plyr--playing') || $(videoID + ' .plyr').hasClass('plyr--ended') ) {
                // Stop & Destroy previous players
                if ( window.player !== undefined ) {
                    window.player.pause();
                    window.player.destroy();
                }

                // console.log('We come from ' + currentSlide + ' & go to: ' + nextSlide);
                if ( $nextSlide.children(".video") ) {
                    let $nextWrapper = $nextSlide.find('.js-videoWrapper');

                    let nextVideoID = '#' + $nextWrapper.attr('id');
                    // let nextPlayers = Plyr.setup(nextVideoID);

                    const nextPlayer = new Plyr(nextVideoID + ' .lazy-video-player', {
                        controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'],
                        settings: ['captions', 'quality', 'speed', 'loop'],
                        youtube: {
                            noCookie: true,
                            rel: 0,
                            showinfo: 0,
                            iv_load_policy: 3,
                            modestbranding: 1,
                        },
                    });

                    // Update player
                    window.player = nextPlayer;

                    // console.log('Before: ' + videoID + '; Next:' + nextVideoID);
                    document.querySelector(nextVideoID).addEventListener('ready', function (e) {
                        e.preventDefault();
                        $nextWrapper.addClass('videoWrapperActive');
                        nextPlayer.play();
                    });

                    document.querySelector(nextVideoID).addEventListener('ended', function (e) {
                          e.preventDefault();
                          $nextWrapper.removeClass('videoWrapperActive');
                          // Next video element
                          let nextVideoIndex = $nextWrapper.parents('.slick-slide').next().data('slick-index');

                          /*
                          const $goToSlide = $(".slick-slide[data-slick-index='" + nextVideoIndex + "']");
                          const $goToWrapper = $goToSlide.find('.js-videoWrapper');
                          const goToVideoID = '#' + $goToWrapper.attr('id');
                          */

                          $nextSlide = $nextWrapper.closest('.media-slider');
                          $nextSlide.slick('slickGoTo', parseInt(nextVideoIndex));
                    });
                }
            }
        }
    },

    // todo: Test if this is working as expected
    moveToNextSlide: function ($slider, nextSlide) {
        $slider.slick('slickGoTo', parseInt(nextSlide));
    },

    sliderFilters: function () {
        let videoFiltered = false,
          photoFiltered = false;

        const slickToFilter = $('.filtering'),
            allFilter = $('a.all-filter'),
            videoFilter = $('a.video-filter'),
            photoFilter = $('a.photo-filter');


        allFilter.on('click', function (e) {
            if ( videoFiltered === true || photoFiltered === true) {
                videoFiltered = false;
                photoFiltered = false;
                slickToFilter.slick('slickUnfilter');
                videoFilter.parent().removeClass('active');
                photoFilter.parent().removeClass('active');
                allFilter.parent().addClass('active');
            } else {
                allFilter.parent().removeClass('active');
            }

            e.preventDefault();
        });

        videoFilter.on('click', function (e) {
            if ( videoFiltered === false) {
                photoFiltered = false;
                photoFilter.parent().removeClass('active');
                slickToFilter.slick('slickUnfilter');
                slickToFilter.slick('slickFilter',$(':has(.video)'));
                $(this).parent().addClass('active');
                allFilter.parent().removeClass('active');
                videoFiltered = true;
            } else {
                slickToFilter.slick('slickUnfilter');
                $(this).parent().removeClass('active');
                allFilter.parent().addClass('active');
                videoFiltered = false;
            }

            e.preventDefault();
        });

        photoFilter.on('click', function (e) {
            if (photoFiltered === false) {
                videoFiltered = false;
                videoFilter.parent().removeClass('active');
                slickToFilter.slick('slickUnfilter');
                slickToFilter.slick('slickFilter',$(':has(.photo)'));
                $(this).parent().addClass('active');
                allFilter.parent().removeClass('active');
                photoFiltered = true;
            } else {
                slickToFilter.slick('slickUnfilter');
                $(this).parent().removeClass('active');
                allFilter.parent().addClass('active');
                photoFiltered = false;
            }

            e.preventDefault();
        });
    },
};
